import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { pricingRateCardApi } from "queries/pricingRateCardApi";

const initState: {
  availablePlans: AvailablePlan[];
  isAvailablePlansLoading: boolean;
  isAvailablePlansError: boolean;
} = {
  availablePlans: [],
  isAvailablePlansLoading: false,
  isAvailablePlansError: false,
};

const availablePlansSlice = createSlice({
  name: "availablePlans",
  initialState: initState,
  reducers: {
    setAvailablePlans: (
      state,
      action: PayloadAction<{ availablePlans: AvailablePlan[] }>,
    ) => {
      state.availablePlans = action.payload.availablePlans;
    },
    setAvailablePlansLoadingStatus: (state, action) => {
      const { loading, error } = action.payload;
      state.isAvailablePlansLoading = loading;
      state.isAvailablePlansError = error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        pricingRateCardApi.endpoints.getRateAvailablePlans.matchPending,
        (state, {}) => {
          state.isAvailablePlansLoading = true;
          state.isAvailablePlansError = false;
          state.availablePlans = [];
        },
      )
      .addMatcher(
        pricingRateCardApi.endpoints.getRateAvailablePlans.matchRejected,
        (state, {}) => {
          state.isAvailablePlansError = true;
          state.isAvailablePlansLoading = false;
        },
      )
      .addMatcher(
        pricingRateCardApi.endpoints.getRateAvailablePlans.matchFulfilled,
        (state, { payload }) => {
          state.availablePlans = payload || [];
          state.isAvailablePlansLoading = false;
          state.isAvailablePlansError = false;
        },
      );
  },
});

export const { setAvailablePlans, setAvailablePlansLoadingStatus } =
  availablePlansSlice.actions;
export const availablePlansSliceReducer = availablePlansSlice.reducer;
